import { useLang } from "@/context/LanguageContext";

export const Marquee = () => {
  const { t } = useLang();
  const words = t.marquee;
  const row = [...words, ...words, ...words, ...words];

  return (
    <div
      data-testid="marquee"
      className="relative overflow-hidden border-y border-hairline bg-sand py-6 md:py-8"
    >
      <div className="flex w-max animate-marquee whitespace-nowrap will-change-transform">
        {row.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display text-4xl font-medium uppercase tracking-tight text-ink/85 md:text-6xl">
              {w}
            </span>
            <span className="mx-8 text-rust md:mx-12" aria-hidden>
              ✳
            </span>
          </span>
        ))}
      </div>
    </div>
  );
};
